<div class="flex justify-center" style="position: relative; z-index: 10">
	<div *ngIf="show"
		 @state
		 [ngClass]="['snackbar-wrap', type]">
		<p class="snackbar-text">
			{{ message }}
		</p>
	</div>
</div>
